<script setup>
import router from '../../routes/index';
const props = defineProps({
  backUrl: {
    type: [String, Object],
    default: '',
  },
  buttonLabel: {
    type: String,
    default: '',
  },
  compact: {
    type: Boolean,
    default: false,
  },
  iconOnly: {
    type: Boolean,
    default: false,
  },
});

const goBack = () => {
  if (props.backUrl !== '') {
    router.push(props.backUrl);
  } else {
    router.go(-1);
  }
};

const buttonStyleClass = props.compact ? 'text-sm' : 'text-base';
</script>

<template>
  <button
    class="acl-back-button flex items-center p-0 font-normal cursor-pointer text-n-slate-11"
    :class="buttonStyleClass"
    :aria-label="buttonLabel || $t('GENERAL_SETTINGS.BACK')"
    :title="iconOnly ? buttonLabel || $t('GENERAL_SETTINGS.BACK') : undefined"
    @click.capture="goBack"
  >
    <i class="acl-back-button__icon i-lucide-chevron-left -ml-1 text-lg" />
    <span v-if="!iconOnly" class="acl-back-button__label">
      {{ buttonLabel || $t('GENERAL_SETTINGS.BACK') }}
    </span>
  </button>
</template>
